/* Motion is progressive enhancement. No content depends on an animation finishing. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const ease = 'cubic-bezier(.22,1,.36,1)';
  const active = new Set();
  let observer;
  const animate = (el, frames, options) => {
    if (reduced.matches || !el?.animate) return;
    const animation = el.animate(frames, options);
    active.add(animation); animation.finished.catch(() => {}).finally(() => active.delete(animation));
    return animation;
  };
  // A one-time line reveal gives the campaign a deliberate editorial entrance.
  const hero = document.querySelector('.campaign h1, .ins-hero h1');
  if (hero && !reduced.matches) {
    [...hero.childNodes].filter(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim()).forEach((text, index) => {
      const mask = document.createElement('span'); mask.className = 'headline-mask';
      const line = document.createElement('span'); line.textContent = text.textContent; mask.append(line); text.replaceWith(mask);
      animate(line, [{ transform: 'translateY(108%)' }, { transform: 'translateY(0)' }], { duration: 850, delay: 90 + index * 85, easing: ease, fill: 'backwards' });
    });
    const detail = document.querySelector('.campaign-copy > p, .ins-hero-intro');
    animate(detail, [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 650, delay: 180, easing: ease, fill: 'backwards' });
  }
  // Editorial moments only: product choice and purchase controls remain immediately usable.
  function observe(scope = document) {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      animate(entry.target, [{ opacity: .25, transform: 'translateY(28px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 650, easing: ease });
    }), { threshold: .14 });
    scope.querySelectorAll('.category-info, .story-content, .outlet-heading, .about-intro, .about-end, .about-statement h2, .about-culture-copy, .about-detail > div, .about-close').forEach(el => {
      if (!el.dataset.motionReady) { el.dataset.motionReady = 'true'; observer.observe(el); }
    });
  }
  observe();
  // Native accordions stay accessible and work with JavaScript disabled.
  document.addEventListener('click', event => {
    const summary = event.target.closest('.accordion > summary, .ins-faq summary');
    if (!summary || event.detail === 0 || summary.parentElement.open) return;
    const body = summary.nextElementSibling;
    requestAnimationFrame(() => animate(body, [{ opacity: .3, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 240, easing: ease }));
  });
  // Progressive scroll-driven imagery; no scroll interception or perpetual RAF loop.
  if (CSS.supports('animation-timeline: view()') && !reduced.matches) document.documentElement.classList.add('scroll-motion');
  reduced.addEventListener('change', () => {
    if (reduced.matches) { observer?.disconnect(); active.forEach(a => a.cancel()); document.documentElement.classList.remove('scroll-motion'); }
    else { observe(); if (CSS.supports('animation-timeline: view()')) document.documentElement.classList.add('scroll-motion'); }
  });
  document.addEventListener('shopify:section:load', event => observe(event.target));
})();
